<template>
    <div class="lesson-group-list">
        <div class="container lesson-group-fix">
            <el-card v-for="item in $options.filters.getList(groupList, '1')" :key="item.uid">
                <el-row>
                    <el-col :span="14">
                        <div>
                            <p class="headinfoline">
                                <span class="coloro">固定分组</span>
                            </p>
                            <h3 class="activityname" v-text="item.name"></h3>
                            <p class="littletips">*本分组主要应用于成绩统计，考勤等活动的默认分组</p>
                        </div>
                    </el-col>
                    <el-col class="fixednumbox" :span="8">
                        <el-row>
                            <el-col :span="12">
                                <p class="numshow" v-text="item.groupNum"></p>
                                <p class="numdesc">组数</p>
                            </el-col>
                            <el-col :span="12">
                                <p class="numshow" v-text="item.hasNoGroupNum"></p>
                                <p class="numdesc">未进组人数</p>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="fixeddetail" :span="2">
                        <el-button type="text" size="mini" @click="gotoTeam(item.uid)">
                            查看详情
                            <i class="el-icon-arrow-right el-icon--right"></i>
                        </el-button>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div class="container">
            <el-row>
                <template>
                    <el-col :span="12">
                        <span>任务分组</span>
                    </el-col>
                    <el-col :span="12">
                        <div style="text-align: right;">
                            <el-button v-if="isAdmin || isTeacher" type="primary" size="small" icon="el-icon-plus"
                                @click="outerVisible = true">新建任务分组</el-button>
                        </div>
                    </el-col>
                </template>
            </el-row>
        </div>
        <div class="container lesson-group-task">
            <el-row>
                <el-col style="padding: 10px;" :span="6" v-for="item in $options.filters.getList(groupList, '2')"
                    :key="item.uid">
                    <el-card :body-style="{ padding: 0 }">
                        <div class="lesson-group-task-body">
                            <el-row class="headinfoline">
                                <el-col :span="12">
                                    <small v-text="item.subTypeText"></small>
                                </el-col>
                                <el-col class="text-r" :span="12">
                                    <el-dropdown size="small" trigger="click" v-if="isAdmin || isTeacher"
                                        @command="handleCommand($event, item.uid)">
                                        <el-button type="text" icon="el-icon-more" size="mini"></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="remove">删除分组</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </el-col>
                            </el-row>
                            <h2 class="activityname" v-text="item.name" @click="gotoTeam(item.uid)"></h2>
                        </div>
                        <el-row class="lesson-group-task-footer">
                            <el-col :span="18">
                                <time>{{item.createTime}}</time>
                            </el-col>
                            <el-col class="text-r" :span="6">
                                <span>小组：<i v-text="item.groupNum"></i></span>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog title="选择新建小组类型" width="30%" :visible.sync="outerVisible">
            <el-dialog width="30%" :title="`新建${$options.filters.subTypeText(form.subType)}`"
                :visible.sync="innerVisible" append-to-body>
                <div>
                    <el-form ref="form" label-width="130px" :model="form" :rules="rules">
                        <el-form-item label="分组标题" prop="groupName">
                            <el-input size="small" v-model="form.groupName"></el-input>
                        </el-form-item>
                        <template v-if="form.subType != 1">
                            <!-- <el-form-item label="系统自动分配组员">
                                <el-switch v-model="form.sysDistribution"></el-switch>
                            </el-form-item> -->
                            <el-form-item label="允许学生新建小组">
                                <el-switch v-model="form.allowStudentsAdd"></el-switch>
                            </el-form-item>
                            <div>
                                <p style="text-align: center;">全班学生共{{studentCount}}人</p>
                                <el-tabs v-model="form.activeName" @tab-click="handleClick">
                                    <el-tab-pane label="按组数" name="first">
                                        <div style="text-align: center;">
                                            <br />
                                            <br />
                                            <p>小组上限<el-input-number size="mini" :min="0" v-model="form.groupNum">
                                                </el-input-number>组</p>
                                            <br />
                                            <p v-if="form.groupNum==0">不限组数</p>
                                            <p v-else>预计每组<span>{{humanNum}}</span>人</p>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane label="按人数" name="second">
                                        <div style="text-align: center;">
                                            <br />
                                            <br />
                                            <p>每组上限<el-input-number size="mini" :min="0" v-model="form.peopleNum">
                                                </el-input-number>人</p>
                                            <br />
                                            <p v-if="form.peopleNum==0">不限人数</p>
                                            <p v-else>预计有<span>{{teamNum}}</span>个小组</p>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </template>
                        <div v-else>
                            <p>*自由分组模式下，不限制学生新建小组的个数、每组人数</p>
                            <p>老师也可以随时对分组及其设置进行调整</p>
                        </div>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="innerVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addGroup('form')">确定</el-button>
                </div>
            </el-dialog>
            <div>
                <el-button type="primary" @click="showAddGroupDialog(1)">自由分组</el-button>
                <el-button type="primary" @click="showAddGroupDialog(2)">有限制分组</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// lessonGroup
import { mapGetters } from 'vuex'
import { addGroup, deleteGroups, queryGroupList } from '@/api/lab/group'
import { getDetail } from '@/api/lab/lesson'
export default {
    data () {
        return {
            outerVisible: false, // 选择新建分组类型 对话框
            innerVisible: false, // 新建(自由/有限制)分组 对话框
            form: {},
            rules: {
                groupName: [
                    { required: true, message: '请输入分组标题', trigger: 'blur' }
                ]
            },
            groupList: [], // 分组列表,
            studentCount: {}
        }
    },
    filters: {
        subTypeText: function (subType) {
            return subType === 1 ? '自由分组' : '分组'
        },
        getList: function (list, type) {
            let arr = []
            list.map(item => {
                if (item.groupType == type) {
                    arr.push(item)
                }
            })
            return arr
        }
    },
    created () {
        this.init()
    },
    computed: {
        ...mapGetters(['isStudent', 'isTeacher', 'isAdmin']),
        humanNum () {
            return Math.floor(this.studentCount / this.form.groupNum)
        },
        teamNum () {
            return Math.floor(this.studentCount / this.form.peopleNum)
        }
    },
    methods: {
        init () {
            this.getGroupList()
            this.getDetail()
        },
        getDetail () {
            const { uid } = this.$route.params
            getDetail(uid).then(res => {
                const { studentCount } = res
                this.studentCount = studentCount
            })
        },
        showAddGroupDialog (subType) {
            this.form = {
                subType, // 1 自由分组   2 有限制分组
                groupName: '',
                sysDistribution: false,
                allowStudentsAdd: false,
                activeName: 'first',
                groupNum: 0,
                peopleNum: 0
            }
            this.outerVisible = false
            this.innerVisible = true
        },
        // 点击菜单项触发的事件回调
        handleCommand (command, uid) {
            if (command == 'remove') {
                let uids = [uid]
                this.deleteGroups(uids)
            }
        },
        addGroup (formRef) {
            this.$refs[formRef].validate((valid) => {
                if (valid) {
                    let data = {
                        subType: this.form.subType,
                        groupName: this.form.groupName,
                        lessonUid: this.$route.params.uid,
                        groupLimit: this.form.groupNum,
                        personLimit: this.form.peopleNum,
                        canCreate: this.form.allowStudentsAdd ? 1 : 0
                    }
                    this.innerVisible = false
                    this.form = {}
                    addGroup(data).then(() => {
                        this.$message.success('操作成功')
                        this.getGroupList()
                    })
                } else {
                    return false
                }
            })
        },
        deleteGroups (uids) {
            deleteGroups(uids).then(() => {
                this.$message.success('操作成功')
                this.getGroupList()
            })
        },
        gotoTeam (uid) {
            this.$router.push({
                name: 'lessonGroup',
                params: { uid }
            })
        },
        getGroupList () {
            this.groupList = []
            queryGroupList(1, 10, {
                lessonUid: this.$route.params.uid
            }).then(res => {
                this.groupList = res.list
            })
        },
        handleClick () {
            this.form.groupNum = 0
            this.form.peopleNum = 0
        }
    }
}
</script>


<style lang="less" scoped>
.lesson-group {
    &-list {
        padding-top: 20px;
        padding-bottom: 20px;
        .numshow {
            font-size: 18px;
            line-height: 25px;
        }
        .numdesc {
            font-size: 14px;
            line-height: 30px;
        }
        [class*='el-col-'] {
            float: none;
            display: inline-block;
            vertical-align: middle;
        }
        .headinfoline {
            font-size: 12px;
            line-height: 1.2em;
            .el-dropdown {
                color: inherit;
            }
            .el-button {
                &--text {
                    font-size: 18px;
                    padding: 0;
                    color: inherit;
                }
            }
            small {
                & + .el-dropdown {
                    margin-left: 12px;
                }
            }
        }
        .activityname {
            line-height: 3em;
            font-weight: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
        }
        .fixednumbox {
            text-align: center;
            line-height: 2em;
            padding-left: 6px;
            color: #999;
            border-left: 1px ridge #ccc;
        }
    }
    &-fix,
    &-task {
        padding: 12px;
    }
    &-fix {
        .fixeddetail {
            text-align: right;
        }
        .littletips {
            font-size: 14px;
            color: #aaa;
        }
        & + div {
            margin-top: 20px;
        }
    }
    &-task {
        > .el-row {
            > .el-col {
                &:nth-child(6n + 1) {
                    .lesson-group-task-body {
                        background-color: rgb(15, 150, 130);
                    }
                }
                &:nth-child(6n + 2) {
                    .lesson-group-task-body {
                        background-color: rgb(250, 75, 30);
                    }
                }
                &:nth-child(6n + 3) {
                    .lesson-group-task-body {
                        background-color: #fabe28;
                    }
                }
                &:nth-child(6n + 4) {
                    .lesson-group-task-body {
                        background-color: #87be14;
                    }
                }
                &:nth-child(6n + 5) {
                    .lesson-group-task-body {
                        background-color: #14b4b4;
                    }
                }
                &:nth-child(6n) {
                    .lesson-group-task-body {
                        background-color: #37a0e1;
                    }
                }
            }
        }
        &-body,
        &-footer {
            padding: 20px;
        }
        &-body {
            color: white;
            .headinfoline {
                font-size: 18px;
                margin-top: -8px;
                margin-left: -8px;
            }
            .activityname {
                font-size: 28px;
                text-align: center;
                margin-bottom: -8px;
                cursor: pointer;
            }
        }
        &-footer {
            padding-top: 0;
            padding-bottom: 0;
            font-size: 0.9em;
            line-height: 3em;
            i {
                font-style: normal;
            }
        }
    }
}
</style>
